/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_livemap.js                                                                         */
/**********************************************************************************************************************/
/* Subscriptions Livemap */
HafasWebapp.prototype.subscriptions.livemap = function (_me) {

  if (Hafas.Config.Switches.useLivemap) {
    Hafas.ps.sub('/ui/disableProduct/livemap/webapp', Hafas.bind(_me.Controller.Livemap.disableProduct, _me));
    Hafas.ps.sub('/ui/updatedMapContentDisabledStatus/livemap/webapp', Hafas.bind(_me.Controller.Livemap.toggleVisibilityHint, _me));
    Hafas.ps.sub('/livemap/setJourneysProductClass/webapp', Hafas.bind(_me.Controller.Livemap.updateLivemap, _me));
    Hafas.ps.sub('/livemap/updateLivemap/webapp', Hafas.bind(_me.Controller.Livemap.updateLivemap, _me));
    Hafas.ps.sub('/livemap/updateCanvasResourcesAndRedraw', Hafas.bind(_me.Controller.Livemap.updateCanvasResourcesAndRedraw, _me));

    Hafas.ps.sub('/mobilityradar/livemapInputUpdate', Hafas.bind(_me.Controller.Livemap.refresh, _me));

    Hafas.ps.sub('/livemap/showRoute', Hafas.bind(_me.Controller.Livemap.showRoute, _me));
    Hafas.ps.sub('/livemap/showOnlyThisJourney', Hafas.bind(_me.Controller.Livemap.showOnlyThisJourney, _me));
    Hafas.ps.sub('/livemap/routeShown', Hafas.bind(_me.Controller.Livemap.updateFlyout, _me));
    Hafas.ps.sub('/livemap/followJourney', Hafas.bind(_me.Controller.Livemap.followJourney, _me));
    Hafas.ps.sub('/livemap/zoomToJourney', Hafas.bind(_me.Controller.Livemap.zoomToJourney, _me));

    Hafas.ps.sub('/livemap/toggleLivemap/webapp', Hafas.bind(_me.Controller.Livemap.toggleLivemap, _me));
    Hafas.ps.sub('/livemap/setJourneyFilter', Hafas.bind(_me.Controller.Livemap.setJourneyFilter, _me));
    Hafas.ps.sub('/livemap/clearJourneyFilter', Hafas.bind(_me.Controller.Livemap.clearJourneyFilter, _me));
    Hafas.ps.sub('/livemap/start', Hafas.bind(_me.Controller.Livemap.startLivemap, _me.Controller.Livemap));
    Hafas.ps.sub('/livemap/stop', Hafas.bind(_me.Controller.Livemap.stopLivemap, _me.Controller.Livemap));
    Hafas.ps.sub('/livemap/setCallbacks', Hafas.bind(_me.Controller.Livemap.setCallbacks, _me.Controller.Livemap));
    Hafas.ps.sub('/livemap/openJourneyToolbox', Hafas.bind(_me.Controller.Livemap.openJourneyToolbox, _me.Controller.Livemap));
    Hafas.ps.sub('/livemap/openTrainrouteFromLivemap', Hafas.bind(_me.Controller.Livemap.openTrainrouteFromLivemap, _me.Controller.Livemap));

    Hafas.ps.sub("/map/zoomend", Hafas.bind(_me.Controller.Livemap.updateInFollowMode, _me));

    //Hafas.ps.sub('/tq/showTrainroute', Hafas.bind(_me.Controller.Livemap.openTrainroute,_me));
    Hafas.ps.sub('/trainroute/showResultData', Hafas.bind(_me.Controller.Livemap.openTrainroute, _me));

    Hafas.ps.sub('/livemap/closeTrainrouteFromLivemap', Hafas.bind(_me.Controller.Livemap.closeTrainrouteFromLivemap, _me.Controller.Livemap));
    Hafas.ps.sub('/GUI/closedAdditionalContainerIndependent/livemap', Hafas.bind(_me.Controller.Livemap.closeTrainrouteFromLivemap, _me.Controller.Livemap));
    Hafas.ps.sub("/livemap/loadResult", Hafas.bind(_me.Controller.Livemap.showLoadingIndicator, _me));
    Hafas.ps.sub("/livemap/loadResultComplete", Hafas.bind(_me.Controller.Livemap.hideLoadingIndicator, _me));
    Hafas.ps.sub('/livemap/loadingCancelled', Hafas.bind(_me.Controller.Livemap.hideLoadingIndicator, _me));
    //Hafas.ps.sub("/map/mousedown/hfsWebappMap", Hafas.bind(_me.Controller.Livemap.stopFollowJourney, _me));
    Hafas.ps.sub('/livemap/followJourney', Hafas.bind(_me.Controller.Livemap.toggleFollowIndicator, _me));
    Hafas.ps.sub("/livemap/updateLivemapContext", Hafas.bind(_me.Controller.Livemap.updateLivemapContext, _me));
    Hafas.ps.sub('/map/showConnectionOnMap', Hafas.bind(_me.Controller.Livemap.showContextLivemapTP, _me));

    Hafas.ps.sub('/map/closeAllToolboxItems', Hafas.bind(_me.Controller.Livemap.clearContentOnFlyoutClose,_me));

    // Folge Modus deaktivieren, wenn auf bestimmten Bereich in der Karte gezoomt wird (linker Kamin)
    Hafas.ps.sub('/tp/details/selectLocation', Hafas.bind(_me.Controller.Livemap.stopFollowJourney, _me));
    Hafas.ps.sub('/tp/centerSegment', Hafas.bind(_me.Controller.Livemap.stopFollowJourney, _me));

    // Livemap Inaktivität
    Hafas.ps.sub('/livemap/inactivity', Hafas.bind(_me.Controller.Livemap.showInactivityPopup, _me));
    Hafas.ps.sub('/livemap/resume', Hafas.bind(_me.Controller.Livemap.resumeLivemap, _me));

    // Initiate train pos mode selector
    if(Hafas.Config.Livemap.showTrainPosModeOption == true) {
      Hafas.ps.sub('/mobilityradar/sidedrawerRerendered', Hafas.bind(_me.Controller.Livemap.initTrainPosModeSelector, _me));
    }
  }
};
